import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../i18n/messages.ts';
import { messages as productRequirementsMessages } from '../i18n/product-requirements-messages.ts';

import { tagBackgroundColors, tagBorderColors, templateStyles } from './styles.ts';

const ProductRequirements: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={348} height={142} fill="none">
      <rect width={336} height={142} fill={templateStyles['background']} rx={3} />
      <mask id="productRequirements-a" fill="#fff">
        <path d="M0 3a3 3 0 0 1 3-3h53v16H0V3Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M56 0h.31v-.31H56V0Zm0 16v.31h.31V16H56ZM0 16h-.31v.31H0V16ZM3 0v.31h53v-.62H3V0Zm53 0h-.31v16h.62V0H56Zm0 16v-.31H0v.62h56V16ZM0 16h.31V3h-.62v13H0ZM3 0v-.31A3.31 3.31 0 0 0-.31 3h.62C.31 1.51 1.51.31 3 .31V0Z"
        mask="url(#productRequirements-a)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M9.64 6.6H5.3v-.47h4.35v.47Zm0 1.63H5.3v-.46h4.35v.46ZM7.47 9.87H5.29V9.4h2.18v.47Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={12.44} y={9.16}>
          {formatMessage(
            productRequirementsMessages['product-requirements.field-1-name']
          )}
        </tspan>
      </text>
      <mask id="productRequirements-b" fill="#fff">
        <path d="M0 16h56v36.66H0V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M56 52.66v.31h.31v-.31H56Zm-56 0h-.31v.31H0v-.31ZM56 16h-.31v36.66h.62V16H56Zm0 36.66v-.31H0v.62h56v-.31Zm-56 0h.31V16H-.3v36.66H0Z"
        mask="url(#productRequirements-b)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={3.73} y={23.15}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-1-cell-1']
          ).substring(0, 23)}
        </tspan>
        <tspan x={2.73} y={29.37}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-1-cell-1']
          ).substring(23, 40)}
        </tspan>
        <tspan x={2.73} y={35.59}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-1-cell-1']
          ).substring(40)}
        </tspan>
      </text>
      <mask id="productRequirements-c" fill="#fff">
        <path d="M0 52.66h56v36.66H0V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M56 89.32v.31h.31v-.31H56Zm-56 0h-.31v.31H0v-.31Zm56-36.66h-.31v36.66h.62V52.66H56Zm0 36.66v-.31H0v.62h56v-.31Zm-56 0h.31V52.66H-.3v36.66H0Z"
        mask="url(#productRequirements-c)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={3.73} y={59.81}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-2-cell-1']
          ).substring(0, 21)}
        </tspan>
        <tspan x={3.73} y={66.03}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-2-cell-1']
          ).substring(21, 41)}
        </tspan>
        <tspan x={2.73} y={72.25}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-2-cell-1']
          ).substring(41)}
        </tspan>
      </text>
      <mask id="productRequirements-d" fill="#fff">
        <path d="M0 89.32h56v36.66H0V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M56 125.98v.31h.31v-.31H56Zm-56 0h-.31v.31H0v-.31Zm56-36.66h-.31v36.66h.62V89.32H56Zm0 36.66v-.31H0v.62h56v-.31Zm-56 0h.31V89.32H-.3v36.66H0Z"
        mask="url(#productRequirements-d)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={3.73} y={96.47}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-3-cell-1']
          ).substring(0, 21)}
        </tspan>
        <tspan x={3.73} y={102.69}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-3-cell-1']
          ).substring(21, 39)}
        </tspan>
        <tspan x={2.73} y={108.91}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-3-cell-1']
          ).substring(39, 57)}
        </tspan>
        <tspan x={3.73} y={115.14}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-3-cell-1']
          ).substring(57)}
        </tspan>
      </text>
      <mask id="productRequirements-e" fill="#fff">
        <path d="M0 125.98h336v13a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-13Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M0 125.98h336H0Zm336.31 13a3.31 3.31 0 0 1-3.31 3.31H3a3.31 3.31 0 0 1-3.31-3.31H.3c0 1.49 1.2 2.69 2.69 2.69h330c1.49 0 2.69-1.2 2.69-2.69h.62ZM3 142.29a3.31 3.31 0 0 1-3.31-3.31v-13H.3v13c0 1.49 1.2 2.69 2.69 2.69v.62Zm333.31-16.31v13a3.31 3.31 0 0 1-3.31 3.31v-.62c1.49 0 2.69-1.2 2.69-2.69v-13h.62Z"
        mask="url(#productRequirements-e)"
      />
      <path
        fill={templateStyles['fontColor']}
        fillRule="evenodd"
        d="M6.57 132.67a.26.26 0 0 0-.52 0v1.05H4.99a.26.26 0 0 0 0 .52h1.06v1.05a.26.26 0 0 0 .52 0v-1.05h1.05a.26.26 0 0 0 0-.52H6.57v-1.05Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={3.68}
        letterSpacing={-0.02}
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={10.51} y={135.29}>
          {formatMessage(messages['templates-preview.add-entry'])}
        </tspan>
      </text>
      <mask id="productRequirements-f" fill="#fff">
        <path d="M56 0h56v16H56V0Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M112 0h.31v-.31H112V0Zm0 16v.31h.31V16H112ZM56 0v.31h56v-.62H56V0Zm56 0h-.31v16h.62V0H112Zm0 16v-.31H56v.62h56V16Z"
        mask="url(#productRequirements-f)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M65.65 6.6h-4.36v-.47h4.36v.47Zm0 1.63h-4.36v-.46h4.36v.46Zm-2.18 1.64h-2.18V9.4h2.18v.47Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={68.45} y={9.16}>
          {formatMessage(
            productRequirementsMessages['product-requirements.field-2-name']
          )}
        </tspan>
      </text>
      <mask id="productRequirements-g" fill="#fff">
        <path d="M56 16h56v36.66H56V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M112 52.66v.31h.31v-.31H112ZM112 16h-.31v36.66h.62V16H112Zm0 36.66v-.31H56v.62h56v-.31Z"
        mask="url(#productRequirements-g)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={59.73} y={23.15}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-1-cell-2']
          ).substring(0, 23)}
        </tspan>
        <tspan x={58.73} y={29.37}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-1-cell-2']
          ).substring(23, 47)}
        </tspan>
        <tspan x={58.73} y={35.59}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-1-cell-2']
          ).substring(47)}
        </tspan>
      </text>
      <mask id="productRequirements-h" fill="#fff">
        <path d="M56 52.66h56v36.66H56V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M112 89.32v.31h.31v-.31H112Zm0-36.66h-.31v36.66h.62V52.66H112Zm0 36.66v-.31H56v.62h56v-.31Z"
        mask="url(#productRequirements-h)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={59.73} y={59.81}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-2-cell-2']
          ).substring(0, 21)}
        </tspan>
        <tspan x={57.73} y={66.03}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-2-cell-2']
          ).substring(21, 45)}
        </tspan>
        <tspan x={57.73} y={72.25}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-2-cell-2']
          ).substring(45)}
        </tspan>
      </text>
      <mask id="productRequirements-i" fill="#fff">
        <path d="M56 89.32h56v36.66H56V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M112 125.98v.31h.31v-.31H112Zm0-36.66h-.31v36.66h.62V89.32H112Zm0 36.66v-.31H56v.62h56v-.31Z"
        mask="url(#productRequirements-i)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={59.73} y={96.47}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-3-cell-2']
          ).substring(0, 21)}
        </tspan>
        <tspan x={59.73} y={102.69}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-3-cell-2']
          ).substring(21, 39)}
        </tspan>
        <tspan x={59.73} y={108.91}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-3-cell-2']
          ).substring(39, 56)}
        </tspan>
        <tspan x={59.73} y={115.14}>
          {formatMessage(
            productRequirementsMessages['product-requirements.entry-3-cell-2']
          ).substring(56)}
        </tspan>
      </text>
      <mask id="productRequirements-j" fill="#fff">
        <path d="M112 0h56v16h-56V0Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M168 0h.31v-.31H168V0Zm0 16v.31h.31V16H168ZM112 0v.31h56v-.62h-56V0Zm56 0h-.31v16h.62V0H168Zm0 16v-.31h-56v.62h56V16Z"
        mask="url(#productRequirements-j)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M119.54 6.2a1.22 1.22 0 0 1 1.73 1.73l-.7.7-.33-.33.7-.7a.76.76 0 0 0-1.07-1.07l-.7.7-.33-.33.7-.7Zm.95 1.1-1.71 1.72-.33-.33 1.7-1.71.34.33Zm-2.82.77.7-.7.33.33-.7.7a.76.76 0 0 0 1.07 1.07l.7-.7.33.33-.7.7a1.22 1.22 0 0 1-1.73-1.73Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={124.45} y={9.16}>
          {formatMessage(
            productRequirementsMessages['product-requirements.field-3-name']
          )}
        </tspan>
      </text>
      <mask id="productRequirements-k" fill="#fff">
        <path d="M112 16h56.62v36.66H112V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M168.62 52.66v.31h.31v-.31h-.3Zm-.3-36.66v36.66h.61V16h-.62Zm.3 36.35H112v.62h56.62v-.62Z"
        mask="url(#productRequirements-k)"
      />
      <g clipPath="url(#productRequirements-l)">
        <rect
          width={49.16}
          height={6.22}
          x={115.73}
          y={18.49}
          fill={templateStyles['background']}
          rx={0.93}
        />
        <g clipPath="url(#productRequirements-m)">
          <path fill={templateStyles['background']} d="M116.67 19.42h4.36v4.36h-4.36z" />
          <path
            fill={templateStyles['link']}
            d="M118.25 21.5c-.05-.04-.11-.04-.14.02l-.7 1.41c-.02.01-.02.03-.02.04a.08.08 0 0 0 .09.08h.98l.04-.01c.02 0 .03-.02.03-.03.22-.44.09-1.1-.28-1.5Zm.51-1.28c-.4.63-.37 1.32-.1 1.84l.47.95c.01.02.04.04.07.04h1.03l.03-.04.01-.04v-.04l-1.36-2.7c-.03-.07-.1-.07-.15 0Z"
          />
        </g>
        <path
          fill={templateStyles['link']}
          d="M123.58 23.56a1.3 1.3 0 0 1-.72-.2c-.2-.12-.36-.31-.47-.55-.1-.24-.16-.52-.16-.85 0-.34.05-.62.16-.86s.27-.43.47-.56c.2-.13.44-.2.72-.2.22 0 .41.05.59.14a1.16 1.16 0 0 1 .65.86h-.38a.84.84 0 0 0-.86-.64c-.2 0-.36.05-.51.15a.98.98 0 0 0-.33.44c-.08.18-.12.4-.12.66s.04.48.12.67a.87.87 0 0 0 .84.59c.15 0 .28-.02.4-.07a.8.8 0 0 0 .28-.2.7.7 0 0 0 .17-.3h.4a1.05 1.05 0 0 1-.66.8c-.17.08-.37.12-.59.12Zm1.84-.07v-2.3h.37v.35h.03a.54.54 0 0 1 .23-.28c.1-.07.23-.1.38-.1h.1l.09.01v.36a1.03 1.03 0 0 0-.23-.02.67.67 0 0 0-.31.07.55.55 0 0 0-.22.2.55.55 0 0 0-.07.29v1.42h-.37Zm2.53.04c-.22 0-.4-.05-.56-.15a.96.96 0 0 1-.37-.4 1.45 1.45 0 0 1-.12-.63c0-.24.04-.45.12-.62a.97.97 0 0 1 .9-.57c.21 0 .4.04.54.14.15.1.27.23.35.4.08.18.12.38.12.6v.15h-1.84v-.3h1.65l-.19.27v-.14c0-.18-.02-.33-.08-.45a.57.57 0 0 0-.55-.34.62.62 0 0 0-.33.09.61.61 0 0 0-.23.26.99.99 0 0 0-.08.44v.14c0 .17.02.3.08.42a.62.62 0 0 0 .6.36c.1 0 .2-.01.27-.04a.6.6 0 0 0 .19-.11.4.4 0 0 0 .1-.14v-.01h.38v.01a.7.7 0 0 1-.11.23.85.85 0 0 1-.2.2 1 1 0 0 1-.28.14c-.1.03-.23.05-.36.05Zm2.18 0a.9.9 0 0 1-.4-.08.68.68 0 0 1-.26-.24.64.64 0 0 1-.1-.36c0-.14.03-.26.1-.35.06-.1.15-.18.28-.23.12-.06.27-.1.45-.1l.84-.05v.3l-.8.04a.7.7 0 0 0-.38.11.31.31 0 0 0-.12.27c0 .12.05.2.13.27.1.07.2.1.34.1.12 0 .23-.03.33-.08s.18-.12.23-.2a.52.52 0 0 0 .09-.3v-.71c0-.14-.05-.25-.13-.32-.09-.08-.22-.12-.39-.12a.68.68 0 0 0-.34.08.36.36 0 0 0-.17.2v.01h-.37v-.01a.6.6 0 0 1 .15-.32.8.8 0 0 1 .31-.2c.13-.06.27-.08.44-.08.18 0 .34.03.47.09.13.06.23.15.3.26.06.11.1.25.1.4v1.58h-.37v-.34h-.04a.76.76 0 0 1-.69.38Zm2.59-.02c-.24 0-.4-.05-.51-.15-.1-.1-.16-.25-.16-.47V21.5h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .13.03.23.08.3.05.05.13.08.25.08a1.4 1.4 0 0 0 .17-.01v.31a2.62 2.62 0 0 1-.21.03Zm1.67.02c-.22 0-.4-.05-.56-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.04-.45.13-.62a.97.97 0 0 1 .9-.57c.2 0 .39.04.53.14.16.1.27.23.35.4.08.18.12.38.12.6v.15h-1.84v-.3h1.65l-.18.27v-.14c0-.18-.03-.33-.08-.45a.57.57 0 0 0-.55-.34.62.62 0 0 0-.34.09.61.61 0 0 0-.22.26.99.99 0 0 0-.09.44v.14c0 .17.03.3.08.42a.62.62 0 0 0 .6.36c.1 0 .2-.01.27-.04a.6.6 0 0 0 .2-.11.4.4 0 0 0 .1-.14v-.01h.37v.01a.7.7 0 0 1-.1.23.85.85 0 0 1-.2.2.98.98 0 0 1-.28.14c-.11.03-.23.05-.37.05Zm3.41 0a.9.9 0 0 1-.4-.08.68.68 0 0 1-.27-.24.64.64 0 0 1-.1-.36c0-.14.04-.26.1-.35.07-.1.16-.18.29-.23.12-.06.27-.1.45-.1l.84-.05v.3l-.8.04a.7.7 0 0 0-.38.11.31.31 0 0 0-.12.27c0 .12.05.2.13.27.1.07.2.1.34.1.12 0 .23-.03.33-.08s.18-.12.23-.2a.52.52 0 0 0 .09-.3v-.71c0-.14-.05-.25-.13-.32-.09-.08-.22-.12-.39-.12a.68.68 0 0 0-.34.08.36.36 0 0 0-.17.2v.01h-.37v-.01a.6.6 0 0 1 .15-.32.8.8 0 0 1 .3-.2c.14-.06.28-.08.44-.08.2 0 .35.03.48.09s.23.15.3.26c.06.11.1.25.1.4v1.58h-.37v-.34h-.04a.76.76 0 0 1-.69.38Zm3.84 0a.88.88 0 0 1-.84-.56 1.52 1.52 0 0 1-.12-.63c0-.24.04-.45.12-.62a.88.88 0 0 1 .84-.56.84.84 0 0 1 .55.19c.07.05.13.13.17.2h.03V20.3h.37v3.2h-.37v-.37h-.03a.77.77 0 0 1-.72.4Zm.09-.33c.14 0 .26-.03.36-.1.1-.07.18-.17.23-.3.06-.13.08-.28.08-.46s-.03-.33-.08-.46a.66.66 0 0 0-.23-.3.61.61 0 0 0-.36-.1.62.62 0 0 0-.36.1.65.65 0 0 0-.23.3 1.2 1.2 0 0 0-.08.46c0 .18.03.34.08.46.06.13.13.23.23.3.1.07.22.1.36.1Zm2.37.33a.9.9 0 0 1-.39-.08.67.67 0 0 1-.27-.24.64.64 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.06-.1.16-.18.28-.23.13-.06.28-.1.45-.1l.85-.05v.3l-.8.04a.7.7 0 0 0-.38.11.32.32 0 0 0-.12.27c0 .12.04.2.13.27s.2.1.33.1.24-.03.34-.08a.6.6 0 0 0 .23-.2.53.53 0 0 0 .08-.3v-.71c0-.14-.04-.25-.13-.32-.08-.08-.21-.12-.38-.12a.68.68 0 0 0-.34.08.36.36 0 0 0-.18.2v.01h-.37v-.01a.62.62 0 0 1 .15-.32.8.8 0 0 1 .31-.2c.13-.06.28-.08.44-.08.19 0 .34.03.47.09.13.06.23.15.3.26.07.11.1.25.1.4v1.58h-.37v-.34h-.03a.78.78 0 0 1-.41.34.9.9 0 0 1-.29.04Zm2.6-.02c-.24 0-.41-.05-.52-.15-.1-.1-.16-.25-.16-.47V21.5h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .13.03.23.08.3.05.05.14.08.26.08a1.38 1.38 0 0 0 .17-.01v.31a2.57 2.57 0 0 1-.22.03Zm1.39.02a.9.9 0 0 1-.4-.08.67.67 0 0 1-.27-.24.65.65 0 0 1-.1-.36c0-.14.04-.26.1-.35.07-.1.16-.18.29-.23.12-.06.27-.1.45-.1l.84-.05v.3l-.8.04a.7.7 0 0 0-.38.11.31.31 0 0 0-.12.27c0 .12.05.2.13.27.1.07.2.1.33.1s.24-.03.34-.08c.1-.05.18-.12.23-.2a.52.52 0 0 0 .09-.3v-.71c0-.14-.05-.25-.13-.32-.09-.08-.22-.12-.39-.12a.69.69 0 0 0-.34.08.36.36 0 0 0-.17.2v.01h-.38v-.01a.61.61 0 0 1 .16-.32.8.8 0 0 1 .3-.2c.14-.06.28-.08.44-.08.2 0 .35.03.48.09s.23.15.3.26c.06.11.1.25.1.4v1.58h-.37v-.34h-.04a.78.78 0 0 1-.4.34.92.92 0 0 1-.3.04Zm2.91 0c-.1 0-.2-.02-.3-.05a.79.79 0 0 1-.24-.14.8.8 0 0 1-.17-.22h-.04v.37h-.37v-3.2h.37v1.27h.04c.04-.08.1-.16.17-.21a.86.86 0 0 1 .54-.19.88.88 0 0 1 .84.56c.08.17.12.38.12.62s-.04.45-.12.63a.88.88 0 0 1-.84.56Zm-.08-.33c.14 0 .26-.03.36-.1.1-.07.17-.17.22-.3.06-.12.09-.28.09-.46s-.03-.33-.09-.46a.64.64 0 0 0-.22-.3.61.61 0 0 0-.36-.1.62.62 0 0 0-.36.1.66.66 0 0 0-.23.3c-.06.13-.09.28-.09.46s.03.33.09.46c.05.13.13.23.23.3.1.07.22.1.36.1Zm2.25.33a.9.9 0 0 1-.4-.08.67.67 0 0 1-.27-.24.64.64 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.06-.1.16-.18.28-.23.13-.06.28-.1.46-.1l.84-.05v.3l-.8.04a.7.7 0 0 0-.38.11.32.32 0 0 0-.12.27c0 .12.04.2.13.27s.2.1.33.1.24-.03.34-.08a.6.6 0 0 0 .23-.2.53.53 0 0 0 .09-.3v-.71c0-.14-.05-.25-.14-.32-.08-.08-.2-.12-.38-.12a.68.68 0 0 0-.34.08.36.36 0 0 0-.17.2v.01h-.38v-.01a.62.62 0 0 1 .15-.32.8.8 0 0 1 .32-.2c.13-.06.27-.08.43-.08.19 0 .35.03.48.09s.23.15.3.26c.06.11.1.25.1.4v1.58h-.38v-.34h-.03a.76.76 0 0 1-.7.38Zm2.56 0c-.17 0-.32-.03-.45-.08a.8.8 0 0 1-.32-.22.6.6 0 0 1-.14-.33h.38c.03.1.1.18.19.23.09.06.2.1.35.1.1 0 .2-.02.27-.05a.47.47 0 0 0 .19-.13.28.28 0 0 0 .07-.18.25.25 0 0 0-.1-.2.73.73 0 0 0-.3-.14l-.36-.09a1.3 1.3 0 0 1-.35-.13.55.55 0 0 1-.2-.2.59.59 0 0 1-.07-.28c0-.13.04-.25.11-.35.08-.1.18-.18.3-.24.14-.06.28-.08.44-.08.16 0 .3.02.43.07.12.05.22.12.3.22.07.09.12.2.14.32h-.37a.38.38 0 0 0-.16-.22.6.6 0 0 0-.34-.09c-.09 0-.17.02-.24.05a.4.4 0 0 0-.17.12.28.28 0 0 0-.06.18c0 .05.01.1.04.14.03.04.07.07.13.1.05.03.12.06.21.08l.36.09c.21.05.37.12.48.22.1.1.16.23.16.4 0 .13-.04.25-.12.36a.8.8 0 0 1-.33.24c-.14.06-.3.09-.47.09Zm2.43 0c-.22 0-.4-.05-.57-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.12-.63c0-.24.04-.45.12-.62a1 1 0 0 1 .36-.42c.16-.1.34-.15.54-.15.21 0 .39.04.54.14.15.1.26.23.34.4.09.18.13.38.13.6v.15h-1.84v-.3h1.65l-.19.27v-.14c0-.18-.02-.33-.08-.45a.57.57 0 0 0-.55-.34.61.61 0 0 0-.33.09.61.61 0 0 0-.23.26.99.99 0 0 0-.08.44v.14c0 .17.02.3.08.42a.62.62 0 0 0 .6.36c.1 0 .19-.01.27-.04a.6.6 0 0 0 .19-.11.4.4 0 0 0 .1-.14v-.01h.38v.01a.7.7 0 0 1-.11.23.85.85 0 0 1-.2.2.98.98 0 0 1-.28.14c-.1.03-.23.05-.36.05Zm1.85-.02a.27.27 0 0 1-.2-.08.27.27 0 0 1-.07-.2c0-.07.02-.14.08-.2a.27.27 0 0 1 .2-.07c.07 0 .13.02.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.27.27 0 0 1-.2.08Zm1.1 0a.27.27 0 0 1-.19-.08.27.27 0 0 1-.08-.2c0-.07.03-.14.08-.2a.27.27 0 0 1 .2-.07c.07 0 .14.02.2.08.05.05.07.12.07.2 0 .07-.02.13-.08.19a.27.27 0 0 1-.2.08Zm1.11 0a.27.27 0 0 1-.27-.28.27.27 0 0 1 .28-.28c.07 0 .14.03.19.09.05.05.08.12.08.2 0 .07-.03.13-.08.19a.27.27 0 0 1-.2.08Z"
        />
      </g>
      <rect
        width={49.16}
        height={6.22}
        x={115.73}
        y={18.49}
        stroke={templateStyles['border']}
        strokeWidth={0.31}
        rx={0.93}
      />
      <mask id="productRequirements-n" fill="#fff">
        <path d="M112 52.66h56.62v36.66H112V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M168.62 89.32v.31h.31v-.31h-.3Zm-.3-36.66v36.66h.61V52.66h-.62Zm.3 36.35H112v.62h56.62v-.62Z"
        mask="url(#productRequirements-n)"
      />
      <g clipPath="url(#productRequirements-o)">
        <rect
          width={49.16}
          height={6.22}
          x={115.73}
          y={55.15}
          fill={templateStyles['background']}
          rx={0.93}
        />
        <g clipPath="url(#productRequirements-p)">
          <path fill={templateStyles['background']} d="M116.67 56.08h4.36v4.36h-4.36z" />
          <path
            fill={templateStyles['link']}
            d="M118.25 58.16c-.05-.04-.11-.04-.14.02l-.7 1.41c-.02.01-.02.03-.02.04a.08.08 0 0 0 .09.08h.98l.04-.01c.02 0 .03-.02.03-.04.22-.43.09-1.1-.28-1.5Zm.51-1.28c-.4.63-.37 1.32-.1 1.84l.47.95c.01.02.04.04.07.04h1.03l.03-.04.01-.04v-.04l-1.36-2.7c-.03-.07-.1-.07-.15 0Z"
          />
        </g>
        <path
          fill={templateStyles['link']}
          d="M122.35 60.15v-3.07h.38v2.72h1.48v.35h-1.86Zm3.06.04a.9.9 0 0 1-.4-.08.67.67 0 0 1-.27-.24.65.65 0 0 1-.1-.36c0-.14.03-.26.1-.35.06-.1.16-.18.28-.23.13-.06.28-.1.45-.1l.85-.05v.3l-.8.04a.7.7 0 0 0-.38.11.32.32 0 0 0-.12.27c0 .12.04.2.13.27s.2.1.33.1.24-.03.34-.08a.6.6 0 0 0 .23-.2.52.52 0 0 0 .08-.3v-.71c0-.14-.04-.25-.13-.32-.08-.08-.21-.12-.38-.12a.68.68 0 0 0-.34.08.36.36 0 0 0-.18.2v.01h-.37v-.01a.61.61 0 0 1 .15-.32.8.8 0 0 1 .31-.2c.13-.06.28-.08.44-.08.19 0 .35.03.48.09s.22.15.29.26c.07.11.1.25.1.4v1.58h-.37v-.34h-.03a.78.78 0 0 1-.41.34.9.9 0 0 1-.28.04Zm1.88.76h-.08l-.08-.01v-.3H127.28a.4.4 0 0 0 .26-.07.56.56 0 0 0 .16-.28l.04-.14-.85-2.3h.4l.7 2.12-.14-.23h.17l-.14.23.7-2.11h.39l-.9 2.43c-.06.17-.12.3-.2.4a.57.57 0 0 1-.24.2c-.09.04-.2.06-.34.06Zm3.03-.76c-.22 0-.4-.05-.57-.14a.97.97 0 0 1-.36-.41 1.45 1.45 0 0 1-.13-.64c0-.24.04-.46.13-.63a.96.96 0 0 1 .93-.55c.21 0 .4.04.56.14.16.1.28.23.36.4.09.18.13.4.13.64 0 .25-.04.46-.13.64a.95.95 0 0 1-.92.55Zm0-.33c.14 0 .26-.03.36-.1.1-.07.18-.17.23-.3.06-.12.08-.28.08-.46s-.02-.34-.08-.46a.62.62 0 0 0-.23-.3.64.64 0 0 0-.36-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3c-.06.12-.08.28-.08.46s.02.34.08.47c.05.12.13.22.23.29.1.07.22.1.37.1Zm2.4.33a.89.89 0 0 1-.44-.1.63.63 0 0 1-.27-.29 1.11 1.11 0 0 1-.08-.46v-1.48h.37v1.4c0 .2.03.35.11.45.09.1.22.15.4.15.1 0 .19-.01.27-.04a.53.53 0 0 0 .2-.13c.04-.06.08-.13.1-.2a.86.86 0 0 0 .05-.28v-1.35h.37v2.29h-.37v-.34h-.03a.63.63 0 0 1-.16.2.65.65 0 0 1-.23.13.93.93 0 0 1-.3.05Zm2.59-.02c-.24 0-.41-.05-.52-.15-.1-.1-.16-.25-.16-.47v-1.39h-.36v-.3h.36v-.6h.39v.6h.5v.3h-.5v1.3c0 .13.02.23.07.3.06.05.14.08.26.08a1.4 1.4 0 0 0 .17-.01v.31a2.62 2.62 0 0 1-.22.03Zm1.5.02c-.16 0-.31-.03-.44-.08a.79.79 0 0 1-.32-.22.6.6 0 0 1-.14-.33h.38c.03.1.1.18.19.23.09.06.2.1.35.1.1 0 .2-.02.27-.05a.46.46 0 0 0 .19-.13.28.28 0 0 0 .07-.18.25.25 0 0 0-.1-.2.73.73 0 0 0-.3-.14l-.36-.09a1.3 1.3 0 0 1-.35-.13.55.55 0 0 1-.2-.2.59.59 0 0 1-.07-.28c0-.13.04-.25.11-.35.07-.1.18-.18.3-.24.14-.06.28-.08.44-.08.16 0 .3.02.43.07.12.05.22.12.3.22.07.09.12.2.14.32h-.37a.37.37 0 0 0-.16-.22.6.6 0 0 0-.34-.09c-.1 0-.17.02-.24.05a.41.41 0 0 0-.17.12.28.28 0 0 0-.06.18c0 .05.01.1.04.14.03.04.07.07.12.1.06.03.13.06.22.08l.36.09c.21.05.37.12.48.22.1.1.16.23.16.4 0 .13-.05.25-.13.36a.8.8 0 0 1-.33.24c-.13.06-.29.09-.46.09Zm3.35 0a.9.9 0 0 1-.39-.08.67.67 0 0 1-.27-.24.64.64 0 0 1-.1-.36c0-.14.03-.26.1-.35.06-.1.16-.18.28-.23.13-.06.28-.1.46-.1l.84-.05v.3l-.8.04a.7.7 0 0 0-.38.11.31.31 0 0 0-.12.27c0 .12.04.2.13.27s.2.1.33.1.24-.03.34-.08c.1-.05.17-.12.23-.2a.52.52 0 0 0 .08-.3v-.71c0-.14-.04-.25-.13-.32-.08-.08-.21-.12-.38-.12a.68.68 0 0 0-.34.08.36.36 0 0 0-.18.2v.01h-.37v-.01a.6.6 0 0 1 .15-.32.8.8 0 0 1 .31-.2c.13-.06.28-.08.44-.08.19 0 .35.03.47.09.13.06.23.15.3.26.07.11.1.25.1.4v1.58h-.37v-.34h-.03a.76.76 0 0 1-.7.38Zm1.78-.04v-2.3h.37v.35h.03a.66.66 0 0 1 .25-.28c.11-.07.25-.1.42-.1.26 0 .46.07.6.22.13.14.2.35.2.62v1.49h-.37v-1.4c0-.2-.04-.36-.13-.46-.09-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.53.53 0 0 0-.2.23.76.76 0 0 0-.08.34v1.36h-.37Zm3.39.04a.88.88 0 0 1-.84-.56 1.53 1.53 0 0 1-.12-.63c0-.24.04-.45.12-.62.08-.18.19-.32.33-.42.15-.1.31-.14.5-.14a.85.85 0 0 1 .55.19c.07.05.13.13.17.2h.04v-1.26h.37v3.2h-.37v-.37h-.04a.77.77 0 0 1-.42.36.87.87 0 0 1-.3.05Zm.08-.33c.14 0 .26-.03.36-.1.1-.07.18-.17.23-.3.06-.13.09-.28.09-.46s-.03-.33-.09-.46a.67.67 0 0 0-.23-.3.62.62 0 0 0-.36-.1.62.62 0 0 0-.36.1.65.65 0 0 0-.23.3c-.05.13-.07.28-.07.46s.02.34.07.46c.06.13.14.23.23.3.1.07.22.1.36.1Zm3.91.33c-.21 0-.4-.05-.56-.14a.97.97 0 0 1-.36-.41 1.45 1.45 0 0 1-.13-.64c0-.24.04-.46.13-.63a.96.96 0 0 1 .92-.55c.22 0 .41.04.57.14.16.1.28.23.36.4.09.18.13.4.13.64 0 .25-.04.46-.13.64a.95.95 0 0 1-.93.55Zm0-.33c.15 0 .27-.03.37-.1.1-.07.18-.17.23-.3.06-.12.08-.28.08-.46s-.02-.34-.08-.46a.62.62 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.36.1.63.63 0 0 0-.24.3 1.2 1.2 0 0 0-.07.46c0 .18.02.34.07.47.06.12.14.22.24.29.1.07.22.1.36.1Zm1.64 1.05v-3.05h.37v.36h.03a.76.76 0 0 1 .42-.36.86.86 0 0 1 .3-.04c.19 0 .36.05.5.14.14.1.26.24.34.42.08.17.12.38.12.62s-.04.45-.12.63a.88.88 0 0 1-.84.56.83.83 0 0 1-.54-.19.68.68 0 0 1-.18-.21h-.03v1.12h-.37Zm1.03-1.05c.14 0 .26-.03.36-.1.1-.07.17-.17.23-.3.05-.12.08-.28.08-.46s-.03-.33-.08-.46a.64.64 0 0 0-.23-.3.61.61 0 0 0-.36-.1.62.62 0 0 0-.36.1.66.66 0 0 0-.23.3c-.06.13-.08.28-.08.46s.02.33.08.46c.05.13.13.23.23.3.1.07.22.1.36.1Zm2.44.3c-.24 0-.4-.04-.51-.14-.1-.1-.16-.25-.16-.47v-1.39h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .13.03.23.08.3.05.05.13.08.25.08a1.36 1.36 0 0 0 .17-.01v.31a2.35 2.35 0 0 1-.21.03Zm.78-.01v-2.3h.36v2.3h-.36Zm.18-2.74a.25.25 0 0 1-.25-.25c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.08c.07 0 .13.03.18.08.05.05.08.1.08.18a.25.25 0 0 1-.26.25Zm1.83 2.78c-.22 0-.41-.05-.57-.14a.97.97 0 0 1-.37-.41 1.45 1.45 0 0 1-.12-.64c0-.24.04-.46.13-.63a.96.96 0 0 1 .93-.55c.21 0 .4.04.56.14.16.1.28.23.36.4.09.18.13.4.13.64 0 .25-.04.46-.13.64a.95.95 0 0 1-.92.55Zm0-.33c.14 0 .26-.03.36-.1.1-.07.18-.17.23-.3.06-.12.08-.28.08-.46s-.02-.34-.08-.46a.62.62 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.36.1.63.63 0 0 0-.23.3 1.2 1.2 0 0 0-.08.46c0 .18.02.34.08.47.05.12.13.22.23.29.1.07.22.1.37.1Zm1.93.31a.27.27 0 0 1-.2-.08.27.27 0 0 1-.08-.2c0-.07.03-.14.08-.2a.27.27 0 0 1 .2-.07c.07 0 .14.02.2.08.05.05.07.12.07.2a.27.27 0 0 1-.27.27Zm1.1 0a.27.27 0 0 1-.2-.08.27.27 0 0 1-.07-.2c0-.07.02-.14.08-.2a.27.27 0 0 1 .2-.07c.07 0 .14.02.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.26.26 0 0 1-.2.08Zm1.11 0a.27.27 0 0 1-.2-.08.27.27 0 0 1-.08-.2c0-.07.03-.14.08-.2a.27.27 0 0 1 .2-.07c.08 0 .14.02.2.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.27.27 0 0 1-.2.08Z"
        />
      </g>
      <rect
        width={49.16}
        height={6.22}
        x={115.73}
        y={55.15}
        stroke={templateStyles['border']}
        strokeWidth={0.31}
        rx={0.93}
      />
      <mask id="productRequirements-q" fill="#fff">
        <path d="M112 89.32h56.62v36.66H112V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M168.62 125.98v.31h.31v-.31h-.3Zm-.3-36.66v36.66h.61V89.32h-.62Zm.3 36.35H112v.62h56.62v-.62Z"
        mask="url(#productRequirements-q)"
      />
      <g clipPath="url(#productRequirements-r)">
        <path
          fill={templateStyles['link']}
          d="M118.25 94.82c-.05-.04-.11-.04-.14.02l-.7 1.41c-.02.01-.02.03-.02.04a.08.08 0 0 0 .09.08h.98l.04-.01c.02 0 .03-.02.03-.03.22-.44.09-1.1-.28-1.5Zm.51-1.28c-.4.63-.37 1.32-.1 1.84l.47.95c.01.02.04.04.07.04h1.03l.03-.04.01-.04v-.04l-1.36-2.7c-.03-.07-.1-.07-.15 0ZM122.35 96.8v-3.06h.38v3.07h-.38Zm1.12 0v-2.28h.37v.35h.03a.6.6 0 0 1 .23-.3.7.7 0 0 1 .39-.1c.1 0 .2.02.28.06.08.03.15.08.21.14.06.06.1.13.14.2h.04c.04-.07.1-.14.16-.2.07-.06.15-.11.24-.14.1-.04.2-.05.3-.05.15 0 .29.02.4.08.1.06.19.15.24.26.06.1.09.24.09.4v1.59h-.37v-1.5c0-.11-.02-.2-.06-.28a.34.34 0 0 0-.15-.17.56.56 0 0 0-.27-.06c-.1 0-.2.03-.28.08a.5.5 0 0 0-.18.19.54.54 0 0 0-.07.27v1.47h-.37v-1.56c0-.09-.02-.17-.06-.23a.39.39 0 0 0-.17-.16.54.54 0 0 0-.25-.06c-.1 0-.19.03-.27.08a.55.55 0 0 0-.19.21.62.62 0 0 0-.06.3v1.42h-.38Zm3.78.77v-3.05h.38v.36h.03a.76.76 0 0 1 .42-.36c.09-.03.19-.04.3-.04.19 0 .36.05.5.14.15.1.26.24.34.42.08.17.12.38.12.62s-.04.45-.12.63a.95.95 0 0 1-.34.41.88.88 0 0 1-.5.15.84.84 0 0 1-.54-.19.7.7 0 0 1-.18-.21h-.03v1.12h-.38Zm1.04-1.05c.14 0 .26-.03.36-.1.1-.07.17-.17.23-.3.05-.12.08-.28.08-.46s-.03-.33-.08-.46a.64.64 0 0 0-.23-.3.61.61 0 0 0-.36-.1.61.61 0 0 0-.36.1.66.66 0 0 0-.23.3c-.06.13-.08.28-.08.46s.02.33.08.46c.05.13.13.23.23.3.1.07.22.1.36.1Zm2.57.33c-.22 0-.4-.05-.57-.14a.96.96 0 0 1-.36-.41 1.43 1.43 0 0 1-.13-.64c0-.24.04-.46.13-.63.08-.18.2-.32.36-.41.16-.1.35-.14.57-.14.21 0 .4.04.56.14.16.1.28.23.36.4.09.18.13.4.13.64 0 .25-.04.46-.13.64a.95.95 0 0 1-.92.55Zm0-.33c.14 0 .26-.03.36-.1.1-.07.18-.17.23-.3.06-.12.08-.28.08-.46s-.02-.34-.08-.46a.63.63 0 0 0-.23-.3.64.64 0 0 0-.36-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3c-.06.12-.08.28-.08.46s.02.34.08.47c.05.12.13.22.23.29.1.07.22.1.37.1Zm1.63.29v-2.3h.37v.35h.03a.55.55 0 0 1 .22-.28c.1-.07.24-.1.4-.1h.1l.08.01v.36a1.08 1.08 0 0 0-.23-.02.67.67 0 0 0-.31.07.54.54 0 0 0-.22.2.55.55 0 0 0-.07.29v1.42h-.37Zm2.51.02c-.23 0-.4-.05-.51-.15-.1-.1-.16-.25-.16-.47v-1.39h-.36v-.3h.36v-.6h.39v.6h.5v.3h-.5v1.3c0 .13.02.23.07.3.05.05.14.08.26.08a1.4 1.4 0 0 0 .17-.01v.31a2.62 2.62 0 0 1-.22.03Zm2.84.02a.88.88 0 0 1-.84-.56 1.53 1.53 0 0 1-.12-.63c0-.24.04-.45.12-.62.08-.18.2-.32.33-.42.15-.1.32-.14.51-.14a.85.85 0 0 1 .55.19c.07.05.13.13.17.2h.03v-1.26h.37v3.2h-.37v-.37h-.03a.78.78 0 0 1-.42.36.87.87 0 0 1-.3.05Zm.09-.33c.14 0 .26-.03.36-.1.1-.07.18-.17.23-.3.05-.13.08-.28.08-.46s-.03-.33-.08-.46a.67.67 0 0 0-.23-.3.62.62 0 0 0-.36-.1.62.62 0 0 0-.36.1.66.66 0 0 0-.23.3c-.05.13-.08.28-.08.46s.03.34.08.46c.05.13.13.23.23.3.1.07.22.1.36.1Zm2.37.33a.9.9 0 0 1-.4-.08.68.68 0 0 1-.27-.24.64.64 0 0 1-.1-.36c0-.14.04-.26.1-.35.07-.1.16-.18.29-.23.12-.06.27-.1.45-.1l.84-.05v.3l-.8.04a.7.7 0 0 0-.38.11.31.31 0 0 0-.12.27c0 .12.05.2.14.27.08.07.2.1.33.1.12 0 .24-.03.33-.08.1-.05.18-.12.23-.2a.52.52 0 0 0 .09-.3v-.71c0-.14-.04-.25-.13-.32-.09-.08-.22-.12-.39-.12a.68.68 0 0 0-.33.08.36.36 0 0 0-.18.2v.01h-.37v-.01a.61.61 0 0 1 .15-.32.8.8 0 0 1 .31-.2c.13-.06.27-.08.44-.08.18 0 .34.03.47.09.13.06.23.15.3.26.06.11.1.25.1.4v1.58h-.37v-.34h-.04a.78.78 0 0 1-.4.34.92.92 0 0 1-.29.04Zm2.59-.02c-.24 0-.4-.05-.51-.15-.1-.1-.16-.25-.16-.47v-1.39h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .13.03.23.08.3.05.05.13.08.25.08a1.4 1.4 0 0 0 .17-.01v.31a2.62 2.62 0 0 1-.21.03Zm1.4.02a.9.9 0 0 1-.4-.08.67.67 0 0 1-.27-.24.64.64 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.06-.1.16-.18.28-.23.13-.06.28-.1.46-.1l.84-.05v.3l-.8.04a.7.7 0 0 0-.38.11.32.32 0 0 0-.12.27c0 .12.04.2.13.27s.2.1.33.1.24-.03.34-.08a.6.6 0 0 0 .23-.2.53.53 0 0 0 .08-.3v-.71c0-.14-.04-.25-.13-.32-.08-.08-.21-.12-.38-.12a.68.68 0 0 0-.34.08.36.36 0 0 0-.18.2v.01h-.37v-.01a.62.62 0 0 1 .15-.32.8.8 0 0 1 .32-.2c.12-.06.27-.08.43-.08.19 0 .35.03.48.09s.22.15.3.26c.06.11.1.25.1.4v1.58H145v-.34h-.03a.78.78 0 0 1-.4.34.9.9 0 0 1-.3.04Zm3-.04v-2.3h.37v2.3h-.37Zm.2-2.74a.25.25 0 0 1-.19-.07.25.25 0 0 1-.08-.18c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.08c.07 0 .13.03.18.08a.25.25 0 0 1 0 .36.24.24 0 0 1-.18.07Zm.87 2.74v-2.3h.37v.35h.03a.65.65 0 0 1 .26-.28c.1-.07.24-.1.41-.1.26 0 .46.07.6.22.13.14.2.35.2.62v1.49h-.36v-1.4c0-.2-.05-.36-.14-.46-.08-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.2.23.77.77 0 0 0-.08.34v1.36h-.37Zm3.36.02c-.24 0-.4-.05-.51-.15-.1-.1-.16-.25-.16-.47v-1.39h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .13.03.23.08.3.05.05.14.08.25.08a1.4 1.4 0 0 0 .17-.01v.31a2.57 2.57 0 0 1-.21.03Zm1.68.02c-.22 0-.4-.05-.56-.14a.96.96 0 0 1-.37-.41 1.45 1.45 0 0 1-.13-.64c0-.24.04-.46.13-.63.09-.18.2-.32.37-.41.16-.1.34-.14.56-.14a.95.95 0 0 1 .93.55c.08.17.13.39.13.63 0 .25-.05.46-.13.64a.96.96 0 0 1-.37.4c-.15.1-.34.15-.56.15Zm0-.33c.14 0 .27-.03.37-.1.1-.07.17-.17.23-.3.05-.12.08-.28.08-.46s-.03-.34-.08-.46a.62.62 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3 1.2 1.2 0 0 0-.08.46c0 .18.03.34.08.47.05.12.13.22.23.29.1.07.22.1.37.1Zm3.05 1.1a.88.88 0 0 1-.16-.02v-.3H156.44a.4.4 0 0 0 .26-.07.56.56 0 0 0 .16-.28l.04-.14-.84-2.3h.4l.7 2.12-.15-.23h.18l-.15.23.7-2.11h.4l-.9 2.43c-.07.17-.13.3-.2.4a.57.57 0 0 1-.25.2c-.09.04-.2.06-.34.06Zm3.03-.77c-.22 0-.4-.05-.57-.14a.97.97 0 0 1-.36-.41 1.45 1.45 0 0 1-.13-.64c0-.24.04-.46.13-.63a.96.96 0 0 1 .93-.55c.22 0 .4.04.56.14.16.1.28.23.37.4.08.18.12.4.12.64 0 .25-.04.46-.13.64a.95.95 0 0 1-.92.55Zm0-.33c.14 0 .27-.03.37-.1.1-.07.17-.17.22-.3.06-.12.09-.28.09-.46s-.03-.34-.09-.46a.62.62 0 0 0-.22-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3 1.2 1.2 0 0 0-.08.46c0 .18.02.34.08.47.05.12.13.22.23.29.1.07.22.1.37.1Zm1.93.31a.27.27 0 0 1-.2-.08.27.27 0 0 1-.08-.2c0-.07.03-.14.09-.2a.27.27 0 0 1 .2-.07c.07 0 .13.02.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.27.27 0 0 1-.2.08Zm1.1 0a.27.27 0 0 1-.19-.08.27.27 0 0 1-.08-.2c0-.07.03-.14.08-.2a.27.27 0 0 1 .2-.07c.07 0 .14.02.2.08.05.05.07.12.07.2 0 .07-.02.13-.08.19a.27.27 0 0 1-.2.08Zm1.11 0a.27.27 0 0 1-.2-.08.27.27 0 0 1-.07-.2c0-.07.02-.14.08-.2a.27.27 0 0 1 .2-.07c.07 0 .13.02.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.27.27 0 0 1-.2.08Z"
        />
      </g>
      <rect
        width={49.16}
        height={6.22}
        x={115.73}
        y={91.81}
        stroke={templateStyles['border']}
        strokeWidth={0.31}
        rx={0.93}
      />
      <mask id="productRequirements-s" fill="#fff">
        <path d="M168 0h57v16h-57V0Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M225 0h.31v-.31H225V0Zm0 16v.31h.31V16H225ZM168 0v.31h57v-.62h-57V0Zm57 0h-.31v16h.62V0H225Zm0 16v-.31h-57v.62h57V16Z"
        mask="url(#productRequirements-s)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M175.27 6a.62.62 0 0 1 .44-.18h1.31c.35 0 .63.28.63.62v1.32c0 .17-.07.32-.19.44l-1.78 1.8a.62.62 0 0 1-.89 0l-1.31-1.32a.62.62 0 0 1 0-.88l1.79-1.8Zm.44.29a.16.16 0 0 0-.11.04l-1.8 1.8a.16.16 0 0 0 0 .21l1.32 1.32c.06.06.16.06.22 0l1.8-1.79a.16.16 0 0 0 .04-.1V6.43a.16.16 0 0 0-.16-.15h-1.31Z"
        clipRule="evenodd"
      />
      <path
        fill={templateStyles['icon']}
        d="M176.09 7.07a.31.31 0 1 1 .62 0 .31.31 0 0 1-.62 0Z"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={180.45} y={9.16}>
          {formatMessage(
            productRequirementsMessages['product-requirements.field-4-name']
          )}
        </tspan>
      </text>
      <mask id="productRequirements-t" fill="#fff">
        <path d="M168 16h56.62v36.66H168V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M224.62 52.66v.31h.31v-.31h-.3Zm-.3-36.66v36.66h.61V16h-.62Zm.3 36.35H168v.62h56.62v-.62Z"
        mask="url(#productRequirements-t)"
      />
      <rect
        width={13.69}
        height={5.91}
        x={171.89}
        y={18.64}
        fill={tagBackgroundColors['redLight']}
        rx={0.78}
      />
      <rect
        width={13.69}
        height={5.91}
        x={171.89}
        y={18.64}
        stroke={tagBorderColors['redLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={173.97} y={22.76}>
          {formatMessage(
            productRequirementsMessages['product-requirements.field-4-select-option-1']
          )}
        </tspan>
      </text>
      <mask id="productRequirements-u" fill="#fff">
        <path d="M168 52.66h56.62v36.66H168V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M224.62 89.32v.31h.31v-.31h-.3Zm-.3-36.66v36.66h.61V52.66h-.62Zm.3 36.35H168v.62h56.62v-.62Z"
        mask="url(#productRequirements-u)"
      />
      <rect
        width={19.69}
        height={5.69}
        x={171.89}
        y={55.3}
        fill={tagBackgroundColors['yellowLight']}
        rx={0.78}
      />
      <rect
        width={19.69}
        height={5.69}
        x={171.89}
        y={55.3}
        stroke={tagBorderColors['yellowLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={173.54} y={59.31}>
          {formatMessage(
            productRequirementsMessages['product-requirements.field-4-select-option-2']
          )}
        </tspan>
      </text>
      <mask id="productRequirements-v" fill="#fff">
        <path d="M168 89.32h56.62v36.66H168V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M224.62 125.98v.31h.31v-.31h-.3Zm-.3-36.66v36.66h.61V89.32h-.62Zm.3 36.35H168v.62h56.62v-.62Z"
        mask="url(#productRequirements-v)"
      />
      <rect
        width={12.69}
        height={5.91}
        x={171.89}
        y={91.96}
        fill={tagBackgroundColors['greenLight']}
        rx={0.78}
      />
      <rect
        width={12.69}
        height={5.91}
        x={171.89}
        y={91.96}
        stroke={tagBorderColors['greenLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={174.12} y={96.08}>
          {formatMessage(
            productRequirementsMessages['product-requirements.field-4-select-option-3']
          )}
        </tspan>
      </text>
      <mask id="productRequirements-w" fill="#fff">
        <path d="M224 0h56v16h-56V0Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M280 0h.31v-.31H280V0Zm0 16v.31h.31V16H280ZM224 0v.31h56v-.62h-56V0Zm56 0h-.31v16h.62V0H280Zm0 16v-.31h-56v.62h56V16Z"
        mask="url(#productRequirements-w)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M231.27 6a.62.62 0 0 1 .44-.18h1.31c.35 0 .63.28.63.62v1.32c0 .17-.07.32-.19.44l-1.78 1.8a.62.62 0 0 1-.89 0l-1.31-1.32a.62.62 0 0 1 0-.88l1.79-1.8Zm.44.29a.16.16 0 0 0-.11.04l-1.8 1.8a.16.16 0 0 0 0 .21l1.32 1.32c.06.06.16.06.22 0l1.8-1.79a.16.16 0 0 0 .04-.1V6.43a.16.16 0 0 0-.16-.15h-1.31Z"
        clipRule="evenodd"
      />
      <path
        fill={templateStyles['icon']}
        d="M232.09 7.07a.31.31 0 1 1 .62 0 .31.31 0 0 1-.62 0Z"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={236.45} y={9.16}>
          {formatMessage(
            productRequirementsMessages['product-requirements.field-5-name']
          )}
        </tspan>
      </text>
      <mask id="productRequirements-x" fill="#fff">
        <path d="M224 16h56v36.66h-56V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M280 52.66v.31h.31v-.31H280ZM279.69 16v36.66h.62V16h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#productRequirements-x)"
      />
      <rect
        width={23.69}
        height={5.91}
        x={227.89}
        y={18.64}
        fill={tagBackgroundColors['greenLight']}
        rx={0.78}
      />
      <rect
        width={23.69}
        height={5.91}
        x={227.89}
        y={18.64}
        stroke={tagBorderColors['greenLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={229.85} y={22.76}>
          {formatMessage(
            productRequirementsMessages['product-requirements.field-5-select-option-3']
          )}
        </tspan>
      </text>
      <mask id="productRequirements-y" fill="#fff">
        <path d="M224 52.66h56v36.66h-56V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M280 89.32v.31h.31v-.31H280Zm-.31-36.66v36.66h.62V52.66h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#productRequirements-y)"
      />
      <rect
        width={27.69}
        height={5.91}
        x={227.89}
        y={55.3}
        fill={tagBackgroundColors['blueLight']}
        rx={0.78}
      />
      <rect
        width={27.69}
        height={5.91}
        x={227.89}
        y={55.3}
        stroke={tagBorderColors['blueLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={230.23} y={59.42}>
          {formatMessage(
            productRequirementsMessages['product-requirements.field-5-select-option-2']
          )}
        </tspan>
      </text>
      <mask id="productRequirements-z" fill="#fff">
        <path d="M224 89.32h56v36.66h-56V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M280 125.98v.31h.31v-.31H280Zm-.31-36.66v36.66h.62V89.32h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#productRequirements-z)"
      />
      <rect
        width={15.69}
        height={5.91}
        x={227.89}
        y={91.96}
        fill={tagBackgroundColors['greyLight']}
        rx={0.78}
      />
      <rect
        width={15.69}
        height={5.91}
        x={227.89}
        y={91.96}
        stroke={tagBorderColors['greyLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={230.04} y={96.08}>
          {formatMessage(
            productRequirementsMessages['product-requirements.field-5-select-option-1']
          )}
        </tspan>
      </text>
      <mask id="productRequirements-A" fill="#fff">
        <path d="M280 0h53a3 3 0 0 1 3 3v13h-56V0Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M280-.31h53A3.31 3.31 0 0 1 336.31 3h-.62c0-1.49-1.2-2.69-2.69-2.69h-53v-.62Zm56.31 16.62H280v-.62h55.69l.62.62ZM280 16V0v16ZM333-.31A3.31 3.31 0 0 1 336.31 3v13.31l-.62-.62V3c0-1.49-1.2-2.69-2.69-2.69v-.62Z"
        mask="url(#productRequirements-A)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M286.38 6.29v.62h.47V6.3h1.24v.62h.47V6.3h.46c.09 0 .16.07.16.15v.94h-3.42v-.94c0-.08.07-.15.15-.15h.47Zm-.62 1.55v1.72c0 .08.07.15.15.15h3.11c.09 0 .16-.07.16-.15V7.84h-3.42Zm2.8-2.02h.46c.35 0 .63.28.63.62v3.12c0 .34-.28.62-.63.62h-3.1a.62.62 0 0 1-.63-.62V6.44c0-.34.28-.62.62-.62h.47v-.3h.47v.3h1.24v-.3h.47v.3Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={292.45} y={9.16}>
          {formatMessage(
            productRequirementsMessages['product-requirements.field-6-name']
          )}
        </tspan>
      </text>
      <mask id="productRequirements-B" fill="#fff">
        <path d="M280 16h56v36.66h-56V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M336 52.66v.31h.31v-.31H336ZM336 16h-.31v36.66h.62V16H336Zm0 36.66v-.31h-56v.62h56v-.31Z"
        mask="url(#productRequirements-B)"
      />
      <rect
        width={28.49}
        height={8.24}
        x={283.73}
        y={18.49}
        fill={templateStyles['userBackground']}
        rx={0.93}
      />
      <path
        fill={templateStyles['fontColor']}
        d="M285.37 24.11v-3.07h1.05c.3 0 .56.06.78.19.22.12.38.29.5.52.11.23.17.5.17.82 0 .33-.06.6-.17.84-.12.22-.28.4-.5.52-.21.12-.47.18-.78.18h-1.05Zm.38-.34h.65c.23 0 .42-.05.58-.14.16-.1.29-.23.37-.41.09-.18.13-.39.13-.64s-.04-.47-.13-.64a.9.9 0 0 0-.37-.41c-.16-.1-.36-.14-.58-.14h-.65v2.38Zm3.67.38c-.22 0-.4-.05-.56-.14a.96.96 0 0 1-.36-.41 1.45 1.45 0 0 1-.13-.63c0-.24.04-.44.13-.62a1 1 0 0 1 .36-.42c.15-.1.33-.15.54-.15.2 0 .39.05.54.14.15.1.26.23.34.4.08.18.12.38.12.6v.15h-1.84v-.3h1.65l-.18.28v-.15c0-.18-.03-.33-.08-.45a.57.57 0 0 0-.55-.34.62.62 0 0 0-.33.09.61.61 0 0 0-.23.27.99.99 0 0 0-.09.43v.15c0 .16.03.3.08.41a.62.62 0 0 0 .6.36c.1 0 .2-.01.27-.04a.6.6 0 0 0 .2-.1.4.4 0 0 0 .1-.14v-.02h.37v.01a.7.7 0 0 1-.1.23.85.85 0 0 1-.2.2.98.98 0 0 1-.28.14c-.11.03-.23.05-.37.05Zm2.5 0a.98.98 0 0 1-.92-.56 1.44 1.44 0 0 1-.14-.63c0-.24.04-.45.13-.63.08-.17.2-.3.36-.4.16-.1.35-.15.56-.15.19 0 .35.03.48.1a.86.86 0 0 1 .48.63v.01h-.37a.53.53 0 0 0-.2-.3.63.63 0 0 0-.39-.11.61.61 0 0 0-.59.4c-.05.12-.08.27-.08.44 0 .18.03.34.08.47.06.13.13.23.24.3.1.07.21.1.35.1.16 0 .28-.03.38-.1.1-.06.17-.16.21-.29v-.01h.37v.02a.98.98 0 0 1-.17.37.8.8 0 0 1-.31.25c-.13.06-.3.1-.48.1Zm3.72-3.18c.14 0 .28.03.41.08a1 1 0 0 1 .38.26c.1.12.2.28.26.48.07.2.1.44.1.73 0 .35-.04.65-.14.9a1.04 1.04 0 0 1-1.04.76c-.17 0-.32-.03-.46-.09a.96.96 0 0 1-.54-.66v-.03h.38v.02c.04.09.08.16.14.23a.6.6 0 0 0 .2.14c.1.03.18.05.29.05.18 0 .33-.05.45-.16s.2-.25.26-.43.09-.38.1-.6v-.11l-.1-.5a.72.72 0 0 0-.34-.63.64.64 0 0 0-.35-.1.7.7 0 0 0-.7.71c.01.14.04.26.1.37.06.1.14.18.24.25.1.05.23.08.36.08.13 0 .25-.03.35-.08a.68.68 0 0 0 .34-.6h.13v.54h-.07a.74.74 0 0 1-.17.24.86.86 0 0 1-.28.17.97.97 0 0 1-.37.07.98.98 0 0 1-.87-.5 1.05 1.05 0 0 1-.13-.53c0-.2.04-.39.13-.55.1-.16.23-.28.39-.37.16-.1.34-.14.55-.14Zm1.5 3.92.2-1.2h.42l-.34 1.2h-.27Zm2.62-.78v-.26l1.03-1.13c.13-.14.24-.25.31-.35.07-.09.13-.17.16-.25a.66.66 0 0 0 .04-.25c0-.1-.02-.2-.07-.29a.5.5 0 0 0-.2-.2.61.61 0 0 0-.31-.08.65.65 0 0 0-.32.08.53.53 0 0 0-.22.21.62.62 0 0 0-.07.32h-.37a.9.9 0 0 1 .49-.81c.15-.09.32-.13.51-.13.18 0 .34.04.49.11.14.08.25.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.11.23-.21.36-.1.13-.25.29-.43.48l-.8.82.1-.18v.18l-.1-.06h1.55v.34h-1.98Zm3.65.07a.9.9 0 0 1-.58-.2 1.23 1.23 0 0 1-.37-.55 2.52 2.52 0 0 1-.13-.85c0-.34.04-.62.13-.86s.2-.42.37-.55a.9.9 0 0 1 .58-.2.9.9 0 0 1 .58.2c.17.13.3.31.38.55.08.24.13.52.13.85 0 .34-.05.62-.13.86-.09.24-.21.43-.38.56a.9.9 0 0 1-.58.2Zm0-.33c.15 0 .27-.05.38-.16a1 1 0 0 0 .24-.44c.06-.19.08-.41.08-.67 0-.27-.02-.5-.08-.68a.98.98 0 0 0-.24-.44.51.51 0 0 0-.38-.15.52.52 0 0 0-.37.15c-.1.1-.19.25-.24.44-.06.19-.09.41-.09.67 0 .27.03.5.09.68a1 1 0 0 0 .24.44c.1.1.23.16.37.16Zm1.72.26v-.26l1.04-1.13c.13-.14.23-.25.3-.35.08-.09.13-.17.16-.25a.66.66 0 0 0 .04-.25c0-.1-.02-.2-.07-.29a.51.51 0 0 0-.2-.2.62.62 0 0 0-.3-.08.65.65 0 0 0-.33.08.53.53 0 0 0-.21.21.62.62 0 0 0-.08.32h-.37a.9.9 0 0 1 .49-.81c.15-.09.32-.13.52-.13.18 0 .34.04.48.11.14.08.26.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.1.23-.21.36-.1.13-.25.29-.43.48l-.8.82.1-.18v.18l-.1-.06h1.56v.34h-2Zm3.67.05c-.21 0-.4-.03-.55-.1a.86.86 0 0 1-.53-.73v-.03h.36v.02c.02.1.05.19.11.27.06.07.15.13.25.18.1.04.23.06.36.06.14 0 .25-.02.35-.07.1-.05.19-.11.24-.2a.5.5 0 0 0 .09-.28.52.52 0 0 0-.2-.44.78.78 0 0 0-.5-.15h-.39v-.32h.37c.12 0 .23-.03.32-.07.1-.05.17-.11.22-.2a.49.49 0 0 0 .08-.27c0-.1-.02-.2-.07-.28a.43.43 0 0 0-.2-.17.76.76 0 0 0-.31-.06.8.8 0 0 0-.33.06c-.09.04-.17.1-.22.18a.53.53 0 0 0-.1.26v.03h-.37v-.03a.9.9 0 0 1 .16-.43.9.9 0 0 1 .35-.3c.15-.06.32-.1.5-.1.2 0 .37.04.52.1.14.07.26.16.34.28a.7.7 0 0 1 .12.41.67.67 0 0 1-.32.59.95.95 0 0 1-.33.14c.22.02.4.1.54.23s.2.3.2.53a.8.8 0 0 1-.13.46.95.95 0 0 1-.38.32c-.16.07-.34.11-.55.11Z"
      />
      <mask id="productRequirements-C" fill="#fff">
        <path d="M280 52.66h56v36.66h-56V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M336 89.32v.31h.31v-.31H336Zm0-36.66h-.31v36.66h.62V52.66H336Zm0 36.66v-.31h-56v.62h56v-.31Z"
        mask="url(#productRequirements-C)"
      />
      <rect
        width={30.49}
        height={8.24}
        x={283.73}
        y={55.15}
        fill={templateStyles['userBackground']}
        rx={0.93}
      />
      <path
        fill={templateStyles['fontColor']}
        d="M285.37 60.77V57.7h1.86v.35h-1.48v1.05h1.36v.34h-1.36v1.33h-.38Zm3.38.04c-.22 0-.4-.05-.56-.14a.96.96 0 0 1-.36-.41 1.45 1.45 0 0 1-.13-.63c0-.24.04-.44.13-.62a1 1 0 0 1 .36-.42c.15-.1.33-.15.54-.15.2 0 .38.05.53.14.15.1.27.23.35.4.08.18.12.38.12.6v.15h-1.84v-.3h1.65l-.18.28v-.15c0-.18-.03-.33-.08-.45a.57.57 0 0 0-.55-.34.62.62 0 0 0-.34.09.61.61 0 0 0-.23.27.99.99 0 0 0-.08.43v.15c0 .16.03.3.08.41a.62.62 0 0 0 .6.36c.1 0 .2-.01.27-.04a.6.6 0 0 0 .19-.1.4.4 0 0 0 .1-.14l.01-.02h.37v.01a.7.7 0 0 1-.1.23.85.85 0 0 1-.2.2.98.98 0 0 1-.29.14c-.1.03-.23.05-.36.05Zm2.7 0c-.11 0-.21-.01-.3-.05a.77.77 0 0 1-.42-.36h-.03v.37h-.38v-3.2h.38v1.27h.03c.04-.08.1-.15.17-.21a.87.87 0 0 1 .54-.19c.2 0 .37.05.5.14.15.1.27.24.35.42.07.17.11.38.11.62 0 .25-.03.45-.11.63a.95.95 0 0 1-.34.41.88.88 0 0 1-.5.15Zm-.1-.33c.15 0 .27-.03.37-.1.1-.07.17-.17.22-.3.06-.12.09-.28.09-.45 0-.19-.03-.34-.08-.47a.63.63 0 0 0-.23-.29.61.61 0 0 0-.36-.1.61.61 0 0 0-.36.1.66.66 0 0 0-.23.3c-.06.12-.08.28-.08.45 0 .18.02.34.08.46.05.13.13.23.23.3.1.07.22.1.36.1Zm2.85.3v-.27l1.04-1.13c.13-.14.23-.25.3-.35.08-.09.13-.17.16-.25a.66.66 0 0 0 .05-.25c0-.1-.03-.2-.07-.29a.5.5 0 0 0-.2-.2.61.61 0 0 0-.31-.08.65.65 0 0 0-.33.08.53.53 0 0 0-.21.21.62.62 0 0 0-.08.32h-.37a.9.9 0 0 1 .49-.81c.15-.09.32-.13.52-.13.18 0 .34.04.48.11.15.08.26.18.34.3a.8.8 0 0 1 .13.45c0 .12-.02.23-.06.34-.04.1-.12.23-.22.36-.1.13-.24.29-.43.48l-.8.82.1-.18v.18l-.09-.06h1.55v.34h-1.99Zm3.67.04c-.2 0-.4-.03-.55-.1a.94.94 0 0 1-.37-.3.85.85 0 0 1-.16-.44v-.02h.37v.02c0 .1.04.19.1.27.07.07.15.13.25.18.1.04.23.06.36.06.14 0 .26-.02.36-.07.1-.05.18-.11.24-.2a.5.5 0 0 0 .08-.28.52.52 0 0 0-.19-.44.78.78 0 0 0-.5-.15h-.4v-.32h.37c.13 0 .23-.03.33-.07.1-.05.16-.11.22-.2a.49.49 0 0 0 .07-.27c0-.1-.02-.2-.06-.28a.43.43 0 0 0-.2-.17.76.76 0 0 0-.32-.06.8.8 0 0 0-.32.06.54.54 0 0 0-.33.44v.03h-.37v-.03a.9.9 0 0 1 .16-.43.9.9 0 0 1 .35-.3c.15-.06.32-.1.51-.1.2 0 .37.04.51.1.15.07.26.16.34.28a.7.7 0 0 1 .12.41.67.67 0 0 1-.31.59.96.96 0 0 1-.34.14c.22.02.4.1.54.23s.21.3.21.53a.8.8 0 0 1-.14.46.96.96 0 0 1-.38.32c-.16.07-.34.11-.55.11Zm1.45.73.19-1.2h.42l-.33 1.2h-.28Zm2.61-.78v-.26l1.04-1.13c.13-.14.23-.25.3-.35.08-.09.13-.17.16-.25a.66.66 0 0 0 .04-.25c0-.1-.02-.2-.07-.29a.52.52 0 0 0-.2-.2.62.62 0 0 0-.3-.08.65.65 0 0 0-.33.08.53.53 0 0 0-.21.21.61.61 0 0 0-.08.32h-.37a.9.9 0 0 1 .49-.82c.15-.08.32-.12.52-.12.18 0 .34.04.48.11.15.08.26.18.34.3a.8.8 0 0 1 .13.45c0 .12-.02.23-.07.34-.04.1-.1.23-.2.36-.11.13-.25.29-.44.48l-.8.82.1-.18v.18l-.1-.06h1.56v.34h-1.99Zm3.66.07a.9.9 0 0 1-.59-.2 1.24 1.24 0 0 1-.37-.55 2.55 2.55 0 0 1-.13-.85c0-.34.05-.62.13-.86.09-.24.21-.42.37-.55a.9.9 0 0 1 .59-.2.9.9 0 0 1 .58.2c.16.13.28.31.37.55.09.24.13.52.13.85 0 .34-.04.62-.13.86s-.21.43-.37.56a.9.9 0 0 1-.58.2Zm0-.33c.14 0 .27-.05.37-.16a1 1 0 0 0 .24-.44c.06-.19.09-.41.09-.67 0-.27-.03-.5-.09-.68a.99.99 0 0 0-.24-.44.51.51 0 0 0-.37-.15.52.52 0 0 0-.38.15 1 1 0 0 0-.24.44c-.05.19-.08.41-.08.67 0 .27.03.5.08.68.06.2.14.34.24.44.1.1.23.16.38.16Zm1.71.26v-.26l1.04-1.13c.13-.14.23-.25.3-.35.08-.09.13-.17.16-.25a.68.68 0 0 0 .05-.25c0-.1-.03-.2-.07-.29a.51.51 0 0 0-.2-.2.61.61 0 0 0-.31-.08.66.66 0 0 0-.33.08.53.53 0 0 0-.21.21.62.62 0 0 0-.08.32h-.36a.9.9 0 0 1 .48-.82c.15-.08.33-.12.52-.12.18 0 .34.04.48.11.15.08.26.18.34.3a.8.8 0 0 1 .13.45c0 .12-.02.23-.06.34-.04.1-.12.23-.22.36-.1.13-.24.29-.43.48l-.8.82.1-.18v.18l-.09-.06h1.55v.34h-1.99Zm3.97 0v-.63h-1.5v-.35a76.59 76.59 0 0 1 .52-.85l.27-.43.26-.41.27-.4h.55v2.1h.44v.34h-.44v.63h-.37Zm-1.1-.98h1.1v-1.73h-.02l-.22.32-.22.34-.22.35a32.83 32.83 0 0 0-.42.7v.02Z"
      />
      <mask id="productRequirements-D" fill="#fff">
        <path d="M280 89.32h56v36.66h-56V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M336 125.98v.31h.31v-.31H336Zm0-36.66h-.31v36.66h.62V89.32H336Zm0 36.66v-.31h-56v.62h56v-.31Z"
        mask="url(#productRequirements-D)"
      />
      <rect
        width={30.49}
        height={8.24}
        x={283.73}
        y={91.81}
        fill={templateStyles['userBackground']}
        rx={0.93}
      />
      <path
        fill={templateStyles['fontColor']}
        d="M285.37 97.43v-3.07h.44l1.05 2.56h.04l1.05-2.56h.44v3.07h-.35V95.1h-.2l.44-.64-1.24 2.98h-.32l-1.23-2.98.42.64h-.18v2.34h-.36Zm4.39.04a.9.9 0 0 1-.4-.08.68.68 0 0 1-.27-.24.64.64 0 0 1-.1-.36c0-.14.04-.26.1-.35.07-.1.16-.18.29-.23.12-.06.27-.09.45-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.31.31 0 0 0-.12.27c0 .12.05.21.13.27.1.07.2.1.33.1s.24-.02.34-.07c.1-.06.18-.12.23-.21a.52.52 0 0 0 .09-.3v-.7c0-.15-.05-.26-.13-.33-.09-.08-.22-.11-.39-.11a.68.68 0 0 0-.34.07.36.36 0 0 0-.17.2v.01h-.38v-.01a.61.61 0 0 1 .16-.31.8.8 0 0 1 .3-.22c.14-.05.28-.07.44-.07.2 0 .35.03.48.09s.23.15.3.26c.06.12.1.25.1.41v1.57h-.37v-.34h-.04a.78.78 0 0 1-.4.34.91.91 0 0 1-.3.04Zm1.88.77a.88.88 0 0 1-.16-.02v-.3H291.63c.1 0 .2-.02.26-.07a.56.56 0 0 0 .16-.28l.05-.14-.85-2.3h.4l.7 2.13-.15-.24h.18l-.15.24.7-2.12h.4l-.9 2.43c-.06.17-.13.3-.2.4a.56.56 0 0 1-.25.2c-.09.05-.2.06-.34.06Zm4.15-.8v-2.65h-.04l-.78.56v-.4l.82-.59h.38v3.07h-.38Zm2.35.06a1.02 1.02 0 0 1-.79-.34c-.1-.12-.2-.28-.27-.48-.06-.2-.1-.44-.1-.73 0-.35.05-.65.15-.9.09-.24.22-.43.4-.56.18-.13.39-.2.64-.2.17 0 .32.03.46.1a.93.93 0 0 1 .54.65v.03h-.38l-.01-.02a.6.6 0 0 0-.34-.37.7.7 0 0 0-.28-.05.64.64 0 0 0-.45.17c-.12.1-.2.25-.26.43a2.33 2.33 0 0 0-.1.64v.06l.1.51c0 .14.02.26.08.37.07.1.15.2.26.26a.67.67 0 0 0 .95-.26.7.7 0 0 0 .09-.36.71.71 0 0 0-.09-.36.63.63 0 0 0-.24-.25.69.69 0 0 0-.36-.1.72.72 0 0 0-.35.1.67.67 0 0 0-.35.6h-.12v-.55h.07a.85.85 0 0 1 .45-.4c.1-.05.23-.07.37-.07a1 1 0 0 1 .52.13c.15.09.27.21.35.36.09.16.13.34.13.53 0 .21-.04.4-.14.55a1 1 0 0 1-.38.38c-.16.09-.34.13-.55.13Zm1.45.71.18-1.2h.43l-.34 1.2h-.27Zm2.6-.78v-.26l1.05-1.13c.13-.14.23-.25.3-.35.08-.09.13-.17.16-.25a.66.66 0 0 0 .04-.25c0-.1-.02-.2-.07-.29a.52.52 0 0 0-.2-.2.62.62 0 0 0-.3-.08.65.65 0 0 0-.33.08.54.54 0 0 0-.21.21.62.62 0 0 0-.08.32h-.37a.9.9 0 0 1 .49-.82c.15-.08.32-.12.52-.12.18 0 .34.04.48.11.14.08.26.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.1.23-.21.36-.1.13-.25.29-.43.48l-.8.82.1-.18v.18l-.1-.06h1.55v.34h-1.98Zm3.66.07a.9.9 0 0 1-.58-.2 1.24 1.24 0 0 1-.37-.55 2.55 2.55 0 0 1-.13-.85c0-.34.05-.62.13-.86.09-.24.21-.42.37-.55a.9.9 0 0 1 .58-.2.9.9 0 0 1 .59.2c.16.13.28.31.37.55.09.24.13.52.13.85 0 .34-.04.62-.13.86s-.21.43-.37.56a.9.9 0 0 1-.59.2Zm0-.33c.15 0 .28-.05.38-.16a1 1 0 0 0 .24-.44c.06-.19.09-.41.09-.67 0-.27-.03-.5-.09-.68a.99.99 0 0 0-.24-.44.51.51 0 0 0-.38-.15.52.52 0 0 0-.37.15 1 1 0 0 0-.24.44c-.06.19-.08.41-.08.67 0 .27.02.5.08.68.06.2.13.34.24.44.1.1.23.16.37.16Zm1.72.26v-.26l1.04-1.13c.13-.14.23-.25.3-.35.08-.09.13-.17.16-.25a.68.68 0 0 0 .04-.25c0-.1-.02-.2-.07-.29a.51.51 0 0 0-.2-.2.61.61 0 0 0-.3-.08.66.66 0 0 0-.33.08.53.53 0 0 0-.21.21.62.62 0 0 0-.08.32h-.37a.9.9 0 0 1 .49-.82c.15-.08.32-.12.52-.12.18 0 .34.04.48.11.14.08.26.18.34.3a.8.8 0 0 1 .13.45c0 .12-.02.23-.07.34-.04.1-.1.23-.2.36-.11.13-.25.29-.44.48l-.8.82.1-.18v.18l-.1-.06h1.56v.34h-1.99Zm3.97 0v-.63h-1.5v-.35a76.59 76.59 0 0 1 .52-.85l.27-.43.26-.41.27-.4h.55v2.1h.44v.34h-.44v.63h-.37Zm-1.1-.98h1.1v-1.73h-.03l-.21.32-.22.34-.22.35a32.83 32.83 0 0 0-.43.7v.02Z"
      />
      <mask id="productRequirements-E" fill="#fff">
        <path d="M320 0h13a3 3 0 0 1 3 3v13h-16V0Z" />
      </mask>
      <path fill={templateStyles['background']} d="M320 0h13a3 3 0 0 1 3 3v13h-16V0Z" />
      <path
        fill={templateStyles['border']}
        d="M320 0v-.3h-.3V0h.3Zm16 16v.3h.3V16h-.3Zm-16 0h-.3v.3h.3V16Zm0-16v.3h13v-.6h-13V0Zm16 3h-.3v13h.6V3h-.3Zm0 13v-.3h-16v.6h16V16Zm-16 0h.3V0h-.6v16h.3Zm13-16v.3c1.5 0 2.7 1.2 2.7 2.7h.6A3.3 3.3 0 0 0 333-.3V0Z"
        mask="url(#productRequirements-E)"
      />
      <path fill="#fff" fillOpacity={0.01} d="M324.27 4.27h7.47v7.47h-7.47z" />
      <path
        fill={templateStyles['fontColor']}
        d="M328 5.51c.16 0 .3.12.3.28l.01.03V7.7h1.87a.31.31 0 0 1 .03.62h-1.9v1.87a.31.31 0 0 1-.62.03V8.31h-1.87a.31.31 0 0 1-.03-.62h1.9V5.82c0-.17.14-.3.31-.3Z"
      />
      <defs>
        <clipPath id="productRequirements-l">
          <rect width={49.16} height={6.22} x={115.73} y={18.49} fill="#fff" rx={0.93} />
        </clipPath>
        <clipPath id="productRequirements-m">
          <path fill="#fff" d="M116.67 19.42h4.36v4.36h-4.36z" />
        </clipPath>
        <clipPath id="productRequirements-o">
          <rect width={49.16} height={6.22} x={115.73} y={55.15} fill="#fff" rx={0.93} />
        </clipPath>
        <clipPath id="productRequirements-p">
          <path fill="#fff" d="M116.67 56.08h4.36v4.36h-4.36z" />
        </clipPath>
        <clipPath id="productRequirements-r">
          <rect width={49.16} height={6.22} x={115.73} y={91.81} fill="#fff" rx={0.93} />
        </clipPath>
      </defs>
    </svg>
  );
};
export default ProductRequirements;
